import RegisterIcon from '@material-ui/icons/Assignment';
import LoginIcon from '@material-ui/icons/Fingerprint';
import { useRouter } from 'next/router';
import React, { MouseEventHandler } from 'react';
import NavigationItem from './NavigationItem';

interface AuthNavigationProps {
  onClick?: MouseEventHandler;
}

export default function AuthNavigation({
  onClick = () => null,
}: AuthNavigationProps): JSX.Element {
  const { pathname } = useRouter();

  return (
    <div>
      <NavigationItem
        text="Sign in"
        icon={<LoginIcon />}
        href="/signin"
        selected={pathname === '/signin'}
        onClick={onClick}
      />
      <NavigationItem
        text="Register"
        icon={<RegisterIcon />}
        href="/register"
        selected={pathname === '/register'}
        onClick={onClick}
      />
    </div>
  );
}
